import React from "react";
import { useSelector } from "react-redux";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";

const IntrosSold = () => {
  const { introsSold, introsSoldChange } = useSelector((state) => state.marketing.totals);
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <>
      <NumberDisplay value={introsSold} disableAnimation={isUserQa} />
      <PercentChanged
        changeValue={introsSoldChange}
        toolTip="Percent change from previous month"
        showBorder
      />
    </>
  );
};

export default IntrosSold;
